import { createAsyncThunk } from '@reduxjs/toolkit';
import OrganizationsResource from 'api/service/OrganizationsResource';

export const listOrganizations = createAsyncThunk('properties/listOrganizations', async () => {
  const organizationsResource = new OrganizationsResource();
  const { status, data } = await organizationsResource.list();
  if (status === 200) {
    return data;
  }
  return [];
});
